import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';

import HelpLink from '../../components/HelpLink';
import LazyText from '../../components/LazyText';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';
import { FormContext } from '../context';
import { getFormKey } from '../selectors/form-manager.selectors';

const useStyles = makeStyles({
  wrapper: {
    borderBottom: '1px solid #e9e9e9',
    padding: '16px 0px 16px 8px',
    '& ul': {
      marginLeft: '15px',
    },
  },
  title: {
    fontFamily: 'Proxima Nova',
    fontSize: 20,
    fontWeight: 600,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 2,
    letterSpacing: 'normal',
    paddingTop: 2,
    color: 'var(--black)',
  },
  uiChanges: {
    color: 'orange',
  },
  deltaChanges: {
    color: 'blue',
  },
  addedChanges: {
    color: 'green',
  },
  titleWrapper: {
    alignItems: 'center',
    display: 'flex',
    gap: 3,
  },
  buttonsWrapper: {
    textAlign: 'right',
  },
  marginRight: {
    marginRight: 15,
  },
  rightAlignIcons: {
    float: 'left',
  },
});

const MobileFormHeader = () => {
  const classes = useStyles();
  const formKey = useContext(FormContext);
  const translateString = useTranslation();
  const formName = useSelector((state) => translateString(getFormKey(state, { formKey })));

  useEffect(() => {
    document.title = formName || 'Initiate';
  }, [formName]);

  return (
    <div className={classes.wrapper}>
      <Grid container>
        <Grid className={classes.titleWrapper} item xs={12}>
          <LazyText text={formName}>
            <span className={classes.title} ui-ta={getUITA('CreateHeader')}>
              {formName}
            </span>
            <HelpLink />
          </LazyText>
        </Grid>
      </Grid>
    </div>
  );
};

export default MobileFormHeader;
